import axios from 'axios';

const host = process.env.VUE_APP_API_HOST;

const moduleMenus = {
    namespaced: true,
    state: () => ({
        menus: [],
    }),
    getters: {
        menus: state => {
            return state.menus;
        },
    },
    mutations: {
        /**
         * Set the state menus
         * @param {object} state The state of the Vuex Store
         * @param {object} menus The new value for menus
         */
        setMenus (state, {menus}) {
            state.menus = menus;
        },
    },
    actions: {
        /**
         * Calls the Menu@index api, and fill the state menus
         * @param {object} context Exposes the same set of methods/properties on the store instance
         * @param {string} startDate The returned menus will be 'greater than equal' to the given startDate
         * @param {string} endDate The returned menus will be 'less than equal' to the given endDate
         * @return {Promise<object>}
         */
        fetchMenus (context, {startDate, endDate}) {
            return new Promise((resolve, reject) => {
                let url = host + '/api/v1/menus?date[gte]=' + startDate + '&date[lte]=' + endDate;
                axios.get(url).then((response) => {
                    context.commit('setMenus', {'menus': response.data});
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
    }
}
export default moduleMenus;